/**
 * @generated SignedSource<<fb113dcdfdb69fc2d4ae718ce6b4b875>>
 * @relayHash 7e3d02fab38b521e409ded4959d21ed7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9d32ef547f6134b32fb58783a144faec06915ec944ac999e7c6346b80ca7e138

import type { ConcreteRequest } from 'relay-runtime';
export type services_RecentActivityForWorkspaceSelectionQuery$variables = Record<PropertyKey, never>;
export type services_RecentActivityForWorkspaceSelectionQuery$data = {
  readonly activity: {
    readonly myActivity: {
      readonly all: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly event: {
              readonly eventType: string;
              readonly timestamp: AGG$DateTime;
            };
            readonly object: {
              readonly id: string;
              readonly product: string;
              readonly rootContainerId: string;
              readonly type: string;
            };
          };
        }>;
      };
    } | null;
  } | null;
};
export type services_RecentActivityForWorkspaceSelectionQuery = {
  response: services_RecentActivityForWorkspaceSelectionQuery$data;
  variables: services_RecentActivityForWorkspaceSelectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "arguments": {
        "eventTypes": [
          "viewed"
        ],
        "objectTypes": [
          "workspace"
        ],
        "products": [
          "studio"
        ]
      }
    }
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "concreteType": "ActivityObject",
  "kind": "LinkedField",
  "name": "object",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "product"
    },
    {
      "kind": "ScalarField",
      "name": "rootContainerId"
    }
  ]
},
v3 = {
  "kind": "ScalarField",
  "name": "eventType"
},
v4 = {
  "kind": "ScalarField",
  "name": "timestamp"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "services_RecentActivityForWorkspaceSelectionQuery",
    "selections": [
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "concreteType": "MyActivity",
            "kind": "LinkedField",
            "name": "myActivity",
            "plural": false,
            "selections": [
              {
                "args": (v0/*: any*/),
                "concreteType": "ActivityConnection",
                "kind": "LinkedField",
                "name": "all",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ActivityItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "ActivityNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "concreteType": "ActivityEvent",
                            "kind": "LinkedField",
                            "name": "event",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "all(filter:{\"arguments\":{\"eventTypes\":[\"viewed\"],\"objectTypes\":[\"workspace\"],\"products\":[\"studio\"]}},first:1)"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "services_RecentActivityForWorkspaceSelectionQuery",
    "selections": [
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "concreteType": "MyActivity",
            "kind": "LinkedField",
            "name": "myActivity",
            "plural": false,
            "selections": [
              {
                "args": (v0/*: any*/),
                "concreteType": "ActivityConnection",
                "kind": "LinkedField",
                "name": "all",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ActivityItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "ActivityNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "concreteType": "ActivityEvent",
                            "kind": "LinkedField",
                            "name": "event",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v1/*: any*/)
                            ]
                          },
                          (v1/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "all(filter:{\"arguments\":{\"eventTypes\":[\"viewed\"],\"objectTypes\":[\"workspace\"],\"products\":[\"studio\"]}},first:1)"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9d32ef547f6134b32fb58783a144faec06915ec944ac999e7c6346b80ca7e138",
    "metadata": {},
    "name": "services_RecentActivityForWorkspaceSelectionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "21cfcbc672a7549ea88841f36e12688e";

export default node;
